export const NLossesByVolatilization = 0.56;

export const coefficients = {
  waterConsumption: {
    low: 1.0, // para terminação: (8.3/1000) * animalsQt * 1.0
    average: 1.5, // para terminação: (8.3/1000) * animalsQt * 1.5
    height: 2.0 // para terminação: (8.3/1000) * animalsQt * 2.0
  },
  "CC": {
    waterConsumption: 92.0,
    wasteExcretion: 18.486,
    unity: 'matrizes',
    "N": 88.1 * (1 - NLossesByVolatilization), // 38.764, // offer => 38.764 * animalsQuantity
    "P2O5": 47.1,
    "K2O": 44.8,

  },
  "UC": {
    waterConsumption: 2.7,
    wasteExcretion: 0.478,
    unity: 'leitões',
    "N": 1.6 * (1 - NLossesByVolatilization),
    "P2O5": 0.8,
    "K2O": 1.1,
  },
  "UT": {
    waterConsumption: 8.3,
    wasteExcretion: 1.526,
    unity: 'suínos',
    "N": 8.1 * (1 - NLossesByVolatilization),
    "P2O5": 4.2,
    "K2O": 4
  },
  "WTF1": {
    waterConsumption: 6.9,
    wasteExcretion: 1.299,
    unity: 'suínos',
    "N": 6.6 * (1 - NLossesByVolatilization),
    "P2O5": 3.4,
    "K2O": 3.4
  },
  "WTF2": {
    waterConsumption: 3.8,
    wasteExcretion: 0.718,
    unity: 'suínos',
    "N": 3.5 * (1 - NLossesByVolatilization),
    "P2O5": 1.8,
    "K2O": 1.9
  },
  "UPL": {
    waterConsumption: 26.5,
    wasteExcretion: 5.696,
    unity: 'matrizes',
    "N": 20.3 * (1 - NLossesByVolatilization),
    "P2O5": 12,
    "K2O": 10.9
  },
  "UPD": {
    waterConsumption: 19.3,
    wasteExcretion: 4.162,
    unity: 'matrizes',
    "N": 15.3 * (1 - NLossesByVolatilization),
    "P2O5": 9.5,
    "K2O": 7.4
  },
}

export const nutrientsDemand = [
  {
    "Cultura": "Alfafa",
    "Produtiv_unid": "toneladas matéria seca de forragem/ha",
    "Produtiv_min": 7,
    "Produtiv_max": 15,
    "N_min": 0,
    "N_adic": 0,
    "P2O5_min": 35,
    "P2O5_adic": 10,
    "K2O_min": 100,
    "K2O_adic": 30
  },
  {
    "Cultura": "Amendoim",
    "Produtiv_unid": "toneladas grãos/ha",
    "Produtiv_min": 1,
    "Produtiv_max": 5,
    "N_min": 0,
    "N_adic": 0,
    "P2O5_min": 15,
    "P2O5_adic": 15,
    "K2O_min": 20,
    "K2O_adic": 20
  },
  {
    "Cultura": "Arroz de sequeiro",
    "Produtiv_unid": "toneladas grãos/ha",
    "Produtiv_min": 1,
    "Produtiv_max": 5,
    "N_min": 25,
    "N_adic": 15,
    "P2O5_min": 10,
    "P2O5_adic": 10,
    "K2O_min": 10,
    "K2O_adic": 10
  },
  {
    "Cultura": "Aveia preta",
    "Produtiv_unid": "toneladas grãos/ha",
    "Produtiv_min": 1,
    "Produtiv_max": 5,
    "N_min": 20,
    "N_adic": 20,
    "P2O5_min": 15,
    "P2O5_adic": 15,
    "K2O_min": 10,
    "K2O_adic": 10
  },
  {
    "Cultura": "Canola",
    "Produtiv_unid": "toneladas grãos/ha",
    "Produtiv_min": 1,
    "Produtiv_max": 5,
    "N_min": 20,
    "N_adic": 20,
    "P2O5_min": 10,
    "P2O5_adic": 20,
    "K2O_min": 10,
    "K2O_adic": 15
  },
  {
    "Cultura": "Capim elefante",
    "Produtiv_unid": "toneladas matéria seca de forragem/ha",
    "Produtiv_min": 7,
    "Produtiv_max": 15,
    "N_min": 20,
    "N_adic": 30,
    "P2O5_min": 50,
    "P2O5_adic": 10,
    "K2O_min": 70,
    "K2O_adic": 10
  },
  {
    "Cultura": "Centeio",
    "Produtiv_unid": "toneladas grãos/ha",
    "Produtiv_min": 1,
    "Produtiv_max": 5,
    "N_min": 10,
    "N_adic": 20,
    "P2O5_min": 15,
    "P2O5_adic": 15,
    "K2O_min": 10,
    "K2O_adic": 10
  },
  {
    "Cultura": "Cevada",
    "Produtiv_unid": "toneladas grãos/ha",
    "Produtiv_min": 1,
    "Produtiv_max": 5,
    "N_min": 20,
    "N_adic": 20,
    "P2O5_min": 15,
    "P2O5_adic": 15,
    "K2O_min": 10,
    "K2O_adic": 10
  },
  {
    "Cultura": "Ervilha seca e forrageira",
    "Produtiv_unid": "toneladas grãos/ha",
    "Produtiv_min": 1,
    "Produtiv_max": 5,
    "N_min": 0,
    "N_adic": 0,
    "P2O5_min": 15,
    "P2O5_adic": 15,
    "K2O_min": 20,
    "K2O_adic": 20
  },
  {
    "Cultura": "Ervilhaca",
    "Produtiv_unid": "toneladas grãos/ha",
    "Produtiv_min": 1,
    "Produtiv_max": 5,
    "N_min": 0,
    "N_adic": 0,
    "P2O5_min": 20,
    "P2O5_adic": 20,
    "K2O_min": 25,
    "K2O_adic": 25
  },
  {
    "Cultura": "Feijão",
    "Produtiv_unid": "toneladas grãos/ha",
    "Produtiv_min": 1,
    "Produtiv_max": 5,
    "N_min": 30,
    "N_adic": 20,
    "P2O5_min": 15,
    "P2O5_adic": 15,
    "K2O_min": 20,
    "K2O_adic": 20
  },
  {
    "Cultura": "Girassol",
    "Produtiv_unid": "toneladas grãos/ha",
    "Produtiv_min": 1,
    "Produtiv_max": 5,
    "N_min": 20,
    "N_adic": 20,
    "P2O5_min": 15,
    "P2O5_adic": 15,
    "K2O_min": 15,
    "K2O_adic": 15
  },
  {
    "Cultura": "Pastagens (gramíneas) de inverno",
    "Produtiv_unid": "toneladas matéria seca de forragem/ha",
    "Produtiv_min": 3,
    "Produtiv_max": 10,
    "N_min": 40,
    "N_adic": 30,
    "P2O5_min": 30,
    "P2O5_adic": 10,
    "K2O_min": 30,
    "K2O_adic": 10
  },
  {
    "Cultura": "Gramíneas de estação fria anuais (pastejo)",
    "Produtiv_unid": "toneladas matéria seca de forragem/ha",
    "Produtiv_min": 3,
    "Produtiv_max": 10,
    "N_min": 40,
    "N_adic": 30,
    "P2O5_min": 30,
    "P2O5_adic": 10,
    "K2O_min": 30,
    "K2O_adic": 10
  },
  {
    "Cultura": "Pastagens (gramíneas) de verão",
    "Produtiv_unid": "toneladas matéria seca de forragem/ha",
    "Produtiv_min": 7,
    "Produtiv_max": 15,
    "N_min": 20,
    "N_adic": 30,
    "P2O5_min": 50,
    "P2O5_adic": 10,
    "K2O_min": 70,
    "K2O_adic": 10
  },
  {
    "Cultura": "Gramíneas de estação quente perenes (manutenção) (pastejo)",
    "Produtiv_unid": "toneladas matéria seca de forragem/ha",
    "Produtiv_min": 7,
    "Produtiv_max": 15,
    "N_min": 20,
    "N_adic": 30,
    "P2O5_min": 50,
    "P2O5_adic": 10,
    "K2O_min": 70,
    "K2O_adic": 10
  },
  {
    "Cultura": "Linho",
    "Produtiv_unid": "toneladas grãos/ha",
    "Produtiv_min": 1,
    "Produtiv_max": 5,
    "N_min": 30,
    "N_adic": 20,
    "P2O5_min": 15,
    "P2O5_adic": 15,
    "K2O_min": 15,
    "K2O_adic": 15
  },
  {
    "Cultura": "Milho",
    "Produtiv_unid": "toneladas grãos/ha",
    "Produtiv_min": 3,
    "Produtiv_max": 13,
    "N_min": 25,
    "N_adic": 15,
    "P2O5_min": 45,
    "P2O5_adic": 15,
    "K2O_min": 30,
    "K2O_adic": 10
  },
  {
    "Cultura": "Milho grão",
    "Produtiv_unid": "toneladas grãos/ha",
    "Produtiv_min": 3,
    "Produtiv_max": 13,
    "N_min": 25,
    "N_adic": 15,
    "P2O5_min": 45,
    "P2O5_adic": 15,
    "K2O_min": 30,
    "K2O_adic": 10
  },
  {
    "Cultura": "Milho pipoca",
    "Produtiv_unid": "toneladas grãos/ha",
    "Produtiv_min": 3,
    "Produtiv_max": 11,
    "N_min": 10,
    "N_adic": 15,
    "P2O5_min": 45,
    "P2O5_adic": 15,
    "K2O_min": 30,
    "K2O_adic": 10
  },
  {
    "Cultura": "Milho silagem",
    "Produtiv_unid": "toneladas matéria seca de forragem/ha",
    "Produtiv_min": 6,
    "Produtiv_max": 15,
    "N_min": 50,
    "N_adic": 15,
    "P2O5_min": 50,
    "P2O5_adic": 10,
    "K2O_min": 100,
    "K2O_adic": 20
  },
  {
    "Cultura": "Milho para silagem",
    "Produtiv_unid": "toneladas matéria seca de forragem/ha",
    "Produtiv_min": 6,
    "Produtiv_max": 15,
    "N_min": 50,
    "N_adic": 15,
    "P2O5_min": 50,
    "P2O5_adic": 10,
    "K2O_min": 100,
    "K2O_adic": 20
  },
  {
    "Cultura": "Nabo forrageiro",
    "Produtiv_unid": "toneladas grãos/ha",
    "Produtiv_min": 1,
    "Produtiv_max": 6,
    "N_min": 10,
    "N_adic": 20,
    "P2O5_min": 15,
    "P2O5_adic": 15,
    "K2O_min": 10,
    "K2O_adic": 20
  },
  {
    "Cultura": "Painço",
    "Produtiv_unid": "toneladas grãos/ha",
    "Produtiv_min": 1,
    "Produtiv_max": 6,
    "N_min": 15,
    "N_adic": 15,
    "P2O5_min": 15,
    "P2O5_adic": 15,
    "K2O_min": 10,
    "K2O_adic": 10
  },
  {
    "Cultura": "Soja",
    "Produtiv_unid": "toneladas grãos/ha",
    "Produtiv_min": 3,
    "Produtiv_max": 7,
    "N_min": 0,
    "N_adic": 0,
    "P2O5_min": 45,
    "P2O5_adic": 15,
    "K2O_min": 75,
    "K2O_adic": 25
  },
  {
    "Cultura": "Sorgo grão",
    "Produtiv_unid": "toneladas grãos/ha",
    "Produtiv_min": 3,
    "Produtiv_max": 7,
    "N_min": 25,
    "N_adic": 15,
    "P2O5_min": 30,
    "P2O5_adic": 15,
    "K2O_min": 20,
    "K2O_adic": 10
  },
  {
    "Cultura": "Sorgo silagem",
    "Produtiv_unid": "toneladas matéria seca de forragem/ha",
    "Produtiv_min": 6,
    "Produtiv_max": 15,
    "N_min": 50,
    "N_adic": 15,
    "P2O5_min": 50,
    "P2O5_adic": 10,
    "K2O_min": 100,
    "K2O_adic": 20
  },
  {
    "Cultura": "Tremoço",
    "Produtiv_unid": "toneladas grãos/ha",
    "Produtiv_min": 1,
    "Produtiv_max": 6,
    "N_min": 0,
    "N_adic": 0,
    "P2O5_min": 15,
    "P2O5_adic": 15,
    "K2O_min": 25,
    "K2O_adic": 25
  },
  {
    "Cultura": "Trigo",
    "Produtiv_unid": "toneladas grãos/ha",
    "Produtiv_min": 1,
    "Produtiv_max": 6,
    "N_min": 20,
    "N_adic": 20,
    "P2O5_min": 15,
    "P2O5_adic": 15,
    "K2O_min": 10,
    "K2O_adic": 10
  },
  {
    "Cultura": "Triticale",
    "Produtiv_unid": "toneladas grãos/ha",
    "Produtiv_min": 1,
    "Produtiv_max": 6,
    "N_min": 20,
    "N_adic": 20,
    "P2O5_min": 15,
    "P2O5_adic": 15,
    "K2O_min": 10,
    "K2O_adic": 10
  }
]

export const prices = [
  {
    "Trimestre": "Caminhão-tanque",
    "Unidade": "R$/h",
    "jan/2021": 173.772,
    "fev/2021": 173.772,
    "mar/2021": 173.772,
    "abr/2021": 182.189142857143,
    "mai/2021": 182.189142857143,
    "jun/2021": 182.189142857143,
    "jul/2021": 189.132,
    "ago/2021": 189.132,
    "set/2021": 189.132,
    "out/2021": 198.387428571429,
    "nov/2021": 198.387428571429,
    "dez/2021": 198.387428571429
  },
  {
    "Trimestre": "Trator-tanque",
    "Unidade": "R$/h",
    "jan/2021": 144.81,
    "fev/2021": 144.81,
    "mar/2021": 144.81,
    "abr/2021": 151.824285714286,
    "mai/2021": 151.824285714286,
    "jun/2021": 151.824285714286,
    "jul/2021": 157.61,
    "ago/2021": 157.61,
    "set/2021": 157.61,
    "out/2021": 165.322857142857,
    "nov/2021": 165.322857142857,
    "dez/2021": 165.322857142857
  },
  {
    "Trimestre": "Fertirrigação",
    "Unidade": "R$/h",
    "jan/2021": 37.75,
    "fev/2021": 37.75,
    "mar/2021": 37.75,
    "abr/2021": 39.7053382663848,
    "mai/2021": 39.7053382663848,
    "jun/2021": 39.7053382663848,
    "jul/2021": 41.5010570824524,
    "ago/2021": 41.5010570824524,
    "set/2021": 41.5010570824524,
    "out/2021": 43.0972515856237,
    "nov/2021": 43.0972515856237,
    "dez/2021": 43.0972515856237
  },
  {
    "Trimestre": "Ureia",
    "Unidade": "R$/sc 50 kg",
    "jan/2021": 123.32,
    "fev/2021": 123.32,
    "mar/2021": 123.32,
    "abr/2021": 144.912222222222,
    "mai/2021": 144.912222222222,
    "jun/2021": 144.912222222222,
    "jul/2021": 163.37,
    "ago/2021": 163.37,
    "set/2021": 163.37,
    "out/2021": 231.97,
    "nov/2021": 231.97,
    "dez/2021": 231.97
  },
  {
    "Trimestre": "Superfosfato Triplo",
    "Unidade": "R$/sc 50 kg",
    "jan/2021": 142.02,
    "fev/2021": 142.02,
    "mar/2021": 142.02,
    "abr/2021": 182.93,
    "mai/2021": 182.93,
    "jun/2021": 182.93,
    "jul/2021": 194.73,
    "ago/2021": 194.73,
    "set/2021": 194.73,
    "out/2021": 229.9625,
    "nov/2021": 229.9625,
    "dez/2021": 229.9625
  },
  {
    "Trimestre": "Cloreto Potássio",
    "Unidade": "R$/sc 50 kg",
    "jan/2021": 109.26,
    "fev/2021": 109.26,
    "mar/2021": 109.26,
    "abr/2021": 122.966,
    "mai/2021": 122.966,
    "jun/2021": 122.966,
    "jul/2021": 164.14,
    "ago/2021": 164.14,
    "set/2021": 164.14,
    "out/2021": 248.43,
    "nov/2021": 248.43,
    "dez/2021": 248.43
  }
]
